import flatten from 'lodash/flatten';

function getCaseLogicSiblings(node, caseLogicDescription, filter = () => true) {
  const nodeMap = caseLogicDescription.nodes;
  const parentConnections = node.inputs.inputs.connections;

  const siblings = flatten(
    parentConnections.map((parentConnection) => {
      const parentNode = nodeMap[parentConnection.node];
      const parentOutput = parentNode.outputs[parentConnection.output];
      return parentOutput.connections.map((connection) => connection.node);
    })
  )
    .filter((nodeId) => nodeId !== node.id)
    .filter(filter)
    .map((nodeId) => nodeMap[nodeId]);

  return siblings;
}

export default getCaseLogicSiblings;
